// This file is AUTOGENERATED, do not edit it manually!!!

export const activityList = {
    Activities_Text: '1#{0} attività  #{0} attività',
    Activity: 'Attività',
    Activity_Billing: 'Fatturazione',
    Activity_Cost: 'Costo Attività',
    Activity_CostVariance: 'Variazione costi',
    Activity_HoursLeft: 'sinistra',
    Activity_InternalCost: 'Costi interni',
    Activity_Profit: 'Profitto',
    Add_Task: 'Aggiungere compito',
    Apply_Text: 'Applicare',
    By_Text: 'da',
    Create: 'Creare',
    CreateNewItem: 'Scrivere qui per creare un nuovo progetto o attività...',
    CustomField_Yes: 'Sì',
    DayPluralFormat: '1#Giorno#Giorni',
    Default_Text: 'Predefinito',
    Delete_Text: 'Cancellare',
    Dependency_AddMore_Text: 'Aggiungere ulteriori dipendenze',
    Dependency_Cancel: 'Annullare',
    Dependency_Choose: 'Seleziona un\'attività o scrivere una parola chiave... ',
    Dependency_days: 'giorni',
    Dependency_DelayWarningExample: 'Esempio: -34, 42',
    Dependency_DelayWarningText: 'Inserisci numeri da -1000 a 1000',
    Dependency_DependencyType_Text: 'Tipo dipendenza',
    Dependency_DependsOn_Text: 'Dipende da',
    Dependency_FinishToStart_Minus1: 'L\'attività inizia il giorno precedente al termine di {0}',
    Dependency_FinishToStart_Minus1_Pattern: 'L\'attività inizia <b>il giorno precedente</b> al termine di \"{0}\"',
    Dependency_FinishToStart_Minus2: 'L\'attività inizia {1} prima del termine di {0}',
    Dependency_FinishToStart_Minus2_Pattern: 'L\'attività inizia <b>{1} prima</b> del termine di \"{0}\"',
    Dependency_FinishToStart_Plus0: 'L\'attività inizia il giorno in cui termina {0}',
    Dependency_FinishToStart_Plus0_Pattern: 'L\'attività inizia <b>il giorno in cui</b> termina \"{0}\"',
    Dependency_FinishToStart_Plus1: 'L\'attività inizia il giorno successivo al termine di {0}',
    Dependency_FinishToStart_Plus1_Pattern: 'L\'attività inizia <b>il giorno successivo</b> al termine di \"{0}\"',
    Dependency_FinishToStart_Plus2: 'L\'attività inizia {1} dopo il termine di {0}',
    Dependency_FinishToStart_Plus2_Pattern: 'L\'attività inizia <b>{1} dopo</b> il termine di \"{0}\"',
    Dependency_FinishWhenStarted_Text: 'L\'attività termina quando \"{0}\" inizia',
    Dependency_Lag_Text: 'Scorrimento',
    Dependency_Remove_Text: 'Togliere',
    Dependency_RemoveSingleDependency_Text: 'Rimuovi dipendenza',
    Dependency_Save: 'Salvare',
    Dependency_SelectDependsOn_Text: 'Selezionare Dipendenza',
    Dependency_StartsWhenFinished_Text: 'L\'attività inizia quando \"{0}\" termina',
    Dependency_StartsWhenStarted_Text: 'L\'attività inizia quando \"{0}\" inizia',
    Dependency_StartToFinish_Minus1: 'L\'attività termina il giorno prima dell\'inizio di {0}',
    Dependency_StartToFinish_Minus1_Pattern: 'L\'attività termina <b>il giorno prima</b> dell\'inizio di \"{0}\"',
    Dependency_StartToFinish_Minus2: 'L\'attività termina {1} prima che {0} inizi',
    Dependency_StartToFinish_Minus2_Pattern: 'L\'attività termina <b>{1} prima</b> che \"{0}\" inizi',
    Dependency_StartToFinish_Plus0: 'L\'attività termina il giorno in cui inizia {0}',
    Dependency_StartToFinish_Plus0_Pattern: 'L\'attività termina <b>il giorno in cui</b> inizia \"{0}\"',
    Dependency_StartToFinish_Plus1: 'L\'attività termina il giorno successivo all\'inizio di {0}',
    Dependency_StartToFinish_Plus1_Pattern: 'L\'attività termina <b>il giorno successivo</b> all\'inizio di \"{0}\"',
    Dependency_StartToFinish_Plus2: 'L\'attività termina {1} dopo l\'inizio di {0}',
    Dependency_StartToFinish_Plus2_Pattern: 'L\'attività termina <b>{1} dopo</b> l\'inizio di \"{0}\"',
    Dependency_StartToStart_Minus1: 'L\'attività inizia il giorno precedente all\'inizio di {0}',
    Dependency_StartToStart_Minus1_Pattern: 'L\'attività inizia <b>il giorno precedente</b> all\'inizio di \"{0}\"',
    Dependency_StartToStart_Minus2: 'L\'attività inizia {1} prima dell\'inizio di {0}',
    Dependency_StartToStart_Minus2_Pattern: 'L\'attività inizia <b>{1} prima</b> dell\'inizio di \"{0}\"',
    Dependency_StartToStart_Plus0: 'L\'attività inizia il giorno in cui {0} inizia',
    Dependency_StartToStart_Plus0_Pattern: 'L\'attività inizia <b>il giorno in cui</b> \"{0}\" inizia',
    Dependency_StartToStart_Plus1: 'L\'attività inizia il giorno successivo all\'inizio di {0}',
    Dependency_StartToStart_Plus1_Pattern: 'L\'attività inizia <b>il giorno successivo</b> all\'inizio di \"{0}\"',
    Dependency_StartToStart_Plus2: 'L\'attività inizia {1} dopo l\'inizio di {0}',
    Dependency_StartToStart_Plus2_Pattern: 'L\'attività inizia <b>{1} dopo</b> l\'inizio di \"{0}\"',
    Edit_Text: 'Modificare',
    EnterViewName_Text: 'Inserire nome vista',
    Error_DragAndDrop_BreakingHierarchy: 'Un\'attività non può essere principale rispetto alla sua attività principale.',
    Error_DragAndDrop_CycleDependencies: 'Si creerà una dipendenza ciclica (esempio: A dipende da B, B dipende da A)',
    Error_DragAndDrop_DifferentProjects: 'Le attività coinvolte appartengono a progetti diversi.',
    From: 'da:',
    Hide_Text: 'Nascondere',
    Import_CSV_Text: 'Importare da CSV',
    Import_MSProject_Text: 'Importa da MS Project',
    Import_Text: 'Importa',
    Loading_Text: 'Caricamento...',
    My_Text: ' Io',
    MyPresetName_Text: 'Mio',
    NoSavedViews_Text: 'Nessuna vista salvata.',
    Of: 'di',
    Project: 'Progetto',
    Project_BudgetedCost: 'Costo previsto',
    Project_CostVariance: 'Variazione costi',
    Project_Expenses: 'Spese',
    Project_InternalCost: 'Costi interni',
    Project_ProjectBilling: 'Costo del progetto',
    Project_ProjectProfit: 'Profitto progetto',
    Project_ProjectProfitability: 'Redditività',
    Projects_Text: '1#{0} project#{0} progetti',
    Rename_Text: 'Rinominare',
    Restore_Text: 'Ripristinare',
    Save_Text: 'Salvare',
    SaveAs_Text: 'Salvare come...',
    Share_Text: 'Condividere',
    Show_Text: 'Mostrare',
    SortBy_Text: 'Ordinare per',
    Tooltip_DefaultPresetIcon: 'Selezionare o gestire le viste salvate',
    Tooltip_RevertToDefaultPreset: 'Ripristinare la vista predefinita',
    Tooltip_SaveDefaultPreset: 'Salvare layout e filtri correnti come Vista',
    Unshare_Text: 'Rimuovere la condivisione',
};
